export interface Category {
  slug: string;
  name: string;
  en: string;
  intro: string;
  longDesc: string;
  banner: string;
  tagline: string;
}

export const categories: Category[] = [
  {
    slug: "otherworld",
    name: "异世界穿越",
    en: "Isekai Journey",
    intro: "主人公穿越到魔法大陆、精灵国度与龙族并存的世界，展开冒险与成长。",
    longDesc:
      "异世界穿越是韩国妖精漫画中最受欢迎的世界观之一。主角从现实世界被卷入魔法、精灵与巨龙共存的奇幻大陆，凭借现代知识与坚定意志，逐步揭开世界的秘密。本分类收录热门异世界穿越题材，包含重生、系统、魔法学院与国战权谋等丰富元素，世界观设定完整，剧情张力十足。",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20fantasy%20isekai%20otherworld%20portal%20opening%20between%20two%20worlds%20with%20magical%20light%20and%20floating%20islands%2C%20stylized%20digital%20painting%2C%20emerald%20and%20gold%20color%20palette%2C%20soft%20glow%2C%20cinematic%20composition&width=1600&height=600&seq=cat-otherworld-banner&orientation=landscape",
    tagline: "穿越魔法大陆，开启传奇旅程",
  },
  {
    slug: "elf",
    name: "精灵契约",
    en: "Elf Contract",
    intro: "人类与精灵缔结契约，共享力量与命运，在森林与月光中守护彼此。",
    longDesc:
      "精灵契约围绕人与精灵之间古老而神秘的誓约展开。契约不只是力量的交换，更意味着命运与记忆的彼此牵连。故事多以月光森林、圣树遗迹与古老誓约为背景，探讨信任、守护与羁绊。细腻的情感刻画与奇幻设定并重，是治愈系与燃向兼具的热门题材。",
    banner:
      "https://readdy.ai/api/search-image?query=moonlit%20fairy%20forest%20with%20ancient%20sacred%20tree%20and%20glowing%20elven%20spirits%2C%20stylized%20fantasy%20painting%2C%20emerald%20green%20and%20soft%20gold%20light%2C%20ethereal%20atmosphere&width=1600&height=600&seq=cat-elf-banner&orientation=landscape",
    tagline: "圣树之下，契约即命运",
  },
  {
    slug: "myth",
    name: "妖怪神话",
    en: "Myth & Spirit",
    intro: "九尾狐、山鬼、龙宫……取材东方神话的妖怪传说，在都市与古域间交错。",
    longDesc:
      "妖怪神话融合东方神话传说与现代叙事，将九尾狐、山鬼、龙族、百妖等经典意象重新演绎。作品或发生在古色古香的妖都，或隐于现代都市的霓虹之间，人妖纠葛、因果轮回与神祇博弈层层展开。东方美学与神秘氛围并重，为热爱神话题材的读者提供丰富的阅读体验。",
    banner:
      "https://readdy.ai/api/search-image?query=mythical%20east%20asian%20spirit%20world%20with%20nine%20tailed%20fox%20silhouette%20and%20ancient%20temples%2C%20ink%20wash%20style%20combined%20with%20digital%20art%2C%20crimson%20and%20jade%20tones%2C%20mysterious%20atmosphere&width=1600&height=600&seq=cat-myth-banner&orientation=landscape",
    tagline: "千年传说，妖与人共存的奇妙世界",
  },
];

export const getCategory = (slug: string) => categories.find((c) => c.slug === slug);